import { render, staticRenderFns } from "./dragVerifyImgChip.vue?vue&type=template&id=7d640537&scoped=true"
import script from "./dragVerifyImgChip.vue?vue&type=script&lang=js"
export * from "./dragVerifyImgChip.vue?vue&type=script&lang=js"
import style0 from "./dragVerifyImgChip.vue?vue&type=style&index=0&id=7d640537&prod&scoped=true&lang=css"
import style1 from "./dragVerifyImgChip.vue?vue&type=style&index=1&id=7d640537&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d640537",
  null
  
)

export default component.exports